import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';


export const initObject = {
  id: undefined,
  // title: "",
  maxAnswer: 1,
  formTypeId: 0,
  formTypeTitle: "",
  questionId: 0,
  questionTitle: "",
  isDeleted: false
};

export const columns = [
  // {
  //   dataField: "title",
  //   text: "عنوان",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "formTypeTitle",
    text: "پرسشنامه",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "maxAnswer",
    text: "حداکثر تعداد پاسخ",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },

];

export const formFields = [
  {
    row: 1,
    list: [
      // {
      //   name: "title",
      //   type: "text",
      //   component: Input,
      //   placeholder: "عنوان",
      //   label: "عنوان",
      //   rowIdx: 1,
      //   class: "col-lg-4"
      // },
      {
        name: "formTypeId",
        type: "option",
        component: (props) =>
          <SelectObjectsField api="api/FormType"
            reduxState="formTypes"
            sname="formTypeId"
            label="پرسشنامه" {...props} />,
        placeholder: "پرسشنامه",
        label: "پرسشنامه",
        rowIdx: 2,
        class: "col-lg-6"
      },
      {
        name: "questionId",
        type: "option",
        component: (props) =>
          <SelectObjectsField api="api/Question"
            reduxState="questions"
            sname="questionId"
            label="پرسش" {...props} />,
        placeholder: "پرسش",
        label: "پرسش",
        rowIdx: 3,
        class: "col-lg-6"
      },
      // {
      //   name: "maxAnswer",
      //   type: "text",
      //   component: Input,
      //   placeholder: "حداکثر تعداد پاسخ",
      //   label: "حداکثر تعداد پاسخ",
      //   rowIdx: 4,
      //   class: "col-lg-4"
      // },
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const filterFields = [
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  {
    name: "formTypeId",
    lable: "پرسشنامه",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/FormType"
        reduxState="formTypes"
        sname="formTypeId"
        {...props} />
  },
  // {
  //   name: "questionId",
  //   lable: "پرسش",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/question"
  //       reduxState="questions"
  //       sname="questionId"
  //       {...props} />
  // },
  // {
  //   name: "searchText",
  //   lable: "MODULES.GENERAL.SEARCH",
  //   type: "text",
  //   list: [],
  // },

];

export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    // searchText: "",
    formTypeId: 0,
    questionId: 0
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, formTypeId, questionId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by formTypeId
  filter.formTypeId = formTypeId !== "" ? +formTypeId : 0;
  filter.questionId = questionId !== "" ? +questionId : 0;

  // // Filter by all fields
  // filter.title = searchText;
  // if (searchText) {
  //   filter.title = searchText;
  // }
  newQueryParams.filter = filter;

  // let whereClause = "title.contains(@0)"
  let whereClause = ""
  const whereClauseParameters = [];
  // whereClauseParameters.push(searchText)

  var idx = 0;

  if (filter.formTypeId > 0 && idx === 0) {
    whereClause = `formTypeId=@${idx}`
    whereClauseParameters.push(filter.formTypeId)
    idx++;
  }
  else if (filter.formTypeId > 0 && idx > 0) {
    whereClause = whereClause + ` and formTypeId=@${idx}`
    whereClauseParameters.push(filter.formTypeId)
    idx++;
  }

  if (filter.questionId > 0 && idx === 0) {
    whereClause = `questionId=@${idx}`
    whereClauseParameters.push(filter.questionId)
    idx++;
  }
  else if (filter.questionId > 0 && idx > 0) {
    whereClause = whereClause + ` and questionId=@${idx}`
    whereClauseParameters.push(filter.questionId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  // title: Yup.string()
  //   .required("پر کردن فیلد الزامی است"),
  formTypeId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  questionId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),

});

